<template>
  <div class="details">
    <detail :prop="'Base amount'" :value="`${roundCurrency(tx.baseAmount, tx.baseAssetCode)} ${tx.baseAssetCode}`"/>
    <detail :prop="'Quote amount'" :value="`${roundCurrency(tx.quoteAmount, tx.quoteAssetCode)} ${tx.quoteAssetCode}`"/>
    <detail :prop="'Order'" :value="tx.isBuy ? i18n.trd_order_buy() : i18n.trd_order_sell()"/>
    <detail :prop="'Price'" :value="`${roundCurrency(tx.price, tx.quoteAssetCode)} ${tx.quoteAssetCode}`"/>
    <detail :prop="'Fee'" :value="`${roundCurrency(tx.fee, tx.baseAssetCode)} ${tx.baseAssetCode}`"/>
    <detail :prop="'Date'" :value="i18n.d(tx.createdAt)"/>
    <div class="btn-wrap margin-top">
      <md-button class="btn md-primary" @click="cancelOffer" :disabled="isPending">Cancel order</md-button>
    </div>
  </div>
</template>

<script>
  import DetailsMixin from './details.mixin'
  import SubmitterMixin from '@com/mixins/submitter.mixin'

  import { i18n } from '@js/i18n'
  import {mapActions, mapGetters} from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { ErrorHandler } from '@js/errors/error_handler'
  import { offersService } from '@api/offer.service'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { dispatchAppEvent } from '@js/events/helpers'
  import { commonEvents } from '@js/events/common_events'
  import { confirmAction } from '@js/modals/confirmation_message'
  import CurrencyRound from '@com/mixins/currency.round.mixin'
  import {errors} from '@js/errors/factory'

  export default {
    name: 'manage-orders',
    mixins: [DetailsMixin, SubmitterMixin, CurrencyRound],
    props: {
      tx: { type: Object, require: true }
    },
    data () {
      return {
        i18n
      }
    },
    computed: {
      ...mapGetters([
        vuexTypes.accountBalances,
        vuexTypes.factorData
      ])
    },
    methods: {
      ...mapActions({
        updateTwoFactorData: vuexTypes.SET_TWO_FACTOR_STATE
      }),
      async cancelOffer () {
        if (!await confirmAction()) return
        this.disable()

        try {
          await offersService.cancelOffer({
            baseBalance: this.accountBalances[this.tx.baseAssetCode].balance_id,
            quoteBalance: this.accountBalances[this.tx.quoteAssetCode].balance_id,
            offerId: this.tx.id.toString(),
            price: this.tx.price,
            orderBookId: this.tx.orderBookId.toString()
          })
          dispatchAppEvent(commonEvents.cancelOrder)
          EventDispatcher.dispatchShowSuccessEvent(i18n.trd_offer_canceled())
        } catch (error) {
          if (error instanceof errors.TFAExceededCodeError) {
            EventDispatcher.dispatchShowErrorEvent(i18n.tfa_to_many_attempts())
          } else {
            ErrorHandler.processUnexpected(error)
          }
        }

        this.enable()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .details {
   margin: 16px auto;
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/trade/index/components/manageOrders/ManageOrders.OrderDetails.vue